import type { FunctionComponent } from 'preact'
import { useEffect, useState } from 'preact/hooks'
import { chunkFailed } from '../reload/pageReload'
import { ReloadButton } from '../reload/ReloadButton'
import type { Session } from '../session'

type Screen = FunctionComponent<{ session: Session }>
let loaded: Screen | null = null

/** The shop, loaded on first open so it stays out of the hub's initial JS (T3.9a). */
export function LazyShop({ session }: { session: Session }) {
  const [Shop, setShop] = useState<Screen | null>(() => loaded)
  const [failed, setFailed] = useState(false)
  useEffect(() => {
    if (loaded) return
    let live = true
    import('./ShopScreen').then(
      (m) => {
        loaded = m.ShopScreen
        if (live) setShop(() => m.ShopScreen)
      },
      (err: unknown) => {
        // A stale deploy (D-066): the page reloads once; else this slot offers Reload.
        if (live) setFailed(true)
        chunkFailed(err)
      },
    )
    return () => {
      live = false
    }
  }, [])
  if (Shop) return <Shop session={session} />
  return failed ? <ReloadButton fill /> : null
}
